import { render, staticRenderFns } from "./MaterialsForPage.vue?vue&type=template&id=c03c7992"
import script from "./MaterialsForPage.vue?vue&type=script&lang=js"
export * from "./MaterialsForPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports